<div class="layout-container">
  <!-- Header -->
  <header class="header">
    <div class="header-left">
      <span class="date">{{ currentDate }}</span>
    </div>
    <div class="header-center">
      <h1 class="logo">Cityspeak</h1>
    </div>
    <div class="header-right">
      <button class="icon-button" aria-label="Search" title="Search">
        <img src="assets/Images/search_Icon.png" alt="Search" class="header-icon">
      </button>
      <button class="icon-button" aria-label="Login" title="Login">
        <img src="assets/Images/Login_Icon.png" alt="Login" class="header-icon">
      </button>
    </div>
  </header>

  <!-- Quote Subheader -->
  <div class="quote-banner">
    விடியல் என்பது கிழக்கில் இல்லை உன் தொடர் உழைப்பில்
  </div>

  <!-- Navigation Bar -->
  <nav class="navbar">
    <div class="nav-container">
      <div class="menu-icon-container">
        <img src="assets/Images/menu_i.png" alt="Menu" class="menu-icon">
      </div>
      <div class="nav-tabs">
        <a class="nav-tab" title="Coming soon">News</a>
        <a class="nav-tab" title="Coming soon">Gold Rate</a>
        <a class="nav-tab" [class.active]="activeTab === 'Bigg Boss'" (click)="setActiveTab('Bigg Boss')">Bigg Boss</a>
        <a class="nav-tab" title="Coming soon">AI</a>
      </div>
    </div>
  </nav>

  <!-- Main Content Area -->
  <main class="main-content">
    <!-- Accommodating the home component in the content area -->
    <div class="content-wrapper">
      <router-outlet></router-outlet>
    </div>
  </main>

  <!-- Footer -->
  <footer class="footer">
    <div class="footer-container">
      <div class="footer-left">
        <span>© Copyright 2026 - Cityspeak</span>
      </div>
      <div class="footer-right">
        <a href="#" class="footer-link">About us</a>
        <a href="#" class="footer-link">Terms & conditions</a>
      </div>
    </div>
  </footer>
</div>